import { Box, IconButton, Link, Skeleton } from "@mui/material";

const DashboardFacilitySkeleton = ({facility=true}:any) => {
    return (
        <Box sx={{ width: "100%", mx: "auto", p: 2, pb: 3, minHeight: "100vh" , marginBottom: 5 }}>
            <Box
                sx={{
                    mb: 3,
                    bgcolor: "#fff",
                    borderRadius: 2.5,
                    boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.05) !important",
                }}
            >
                {facility &&  <>
                    <Box sx={{ p: 2, width: "100%", mb: 1, mt:1 }}>
                        <Skeleton variant="rectangular" height={50} />
                    </Box>
                    <Box
                        sx={{
                            borderRadius: "10px!important",
                            boxShadow: "none",
                            px: 2,
                            py: 2
                        }}
                    >
                        <Box
                            sx={{
                                backgroundColor: "#F6FBFF",
                                px: "20px",
                                py: "5px",
                                borderRadius: "10px 10px 10px 10px",
                            }}
                        >
                            <Box display="flex" alignItems="center" justifyContent="space-between" my="10px">
                                <Box display="flex" alignItems="center" gap="30px">
                                    <Box display="flex" alignItems="center" gap="10px">
                                        <Skeleton variant="circular" width={24} height={24} />
                                        <Box>
                                            <Link underline="hover">
                                                <Skeleton variant="text" width={120} />
                                            </Link>
                                        </Box>
                                    </Box>
                                    <Skeleton variant="circular" width={24} height={24} />
                                </Box>
                                <Box display="flex" gap={1}>
                                    <IconButton sx={{ backgroundColor: "#123f93", color: "#fff" }}>
                                        <Skeleton variant="circular" width={24} height={24} />
                                    </IconButton>
                                    <IconButton sx={{ backgroundColor: "#E5F4FF", color: "#32405A" }}>
                                        <Skeleton variant="circular" width={24} height={24} />
                                    </IconButton>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </>}
                <Box sx={{ mt: 2, px: 2, py:2, display: 'flex', flexDirection: 'column', gap: 1 }}>
                    {Array.from({ length: 4 }).map((_, index) => (
                        <Skeleton
                            key={index}
                            variant="rectangular"
                            height={100}
                            sx={{ borderRadius: 2 }}
                        />
                    ))}
                </Box>

            </Box>
        </Box>
    );
};

export default DashboardFacilitySkeleton;
